<dx-scroll-view height="100%" [useNative]="false" [showScrollbar]="'always'">
  <div
    class="association-address-form__validation-container"
    *ngIf="associationFormData?.address?.[AddressModelKeys.validationResponse]?.result as result"
  >
    <p *ngIf="!result?.verdict?.addressComplete">{{ ADDRESS_IS_INCOMPLETE_TEXT }}</p>
    <p *ngIf="result?.verdict?.hasUnconfirmedComponents">{{ ADDRESS_HAS_UNCONFIRMED_DATA_TEXT }}</p>
  </div>

  <dx-validator [validationGroup]="validationGroup" [adapter]="googleAddressValidatorAdapter">
    <dxi-validation-rule
      type="async"
      [validationCallback]="googleValidationCallback"
      [message]="''"
      [reevaluate]="true"
    ></dxi-validation-rule>
  </dx-validator>

  <dx-form [(formData)]="associationFormData" labelMode="floating" [validationGroup]="validationGroup" [colCount]="12">
    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.address1].join('.')"
      [label]="{ text: 'Address 1' }"
      [colSpan]="6"
    >
      <div *dxTemplate>
        <ag-shr-address-autocomplete
          [value]="associationFormData?.address?.[AddressModelKeys.address1]"
          (valueChange)="onAddressAutocompleteChange($event)"
          (addressSelectionChange)="handleAddressSelectionChange($event)"
          [isReadonly]="false"
          [validationGroup]="validationGroup"
        ></ag-shr-address-autocomplete>
      </div>
    </dxi-item>

    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.address2].join('.')"
      [label]="{ text: 'Address 2' }"
      [colSpan]="6"
    ></dxi-item>

    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.city].join('.')"
      [label]="{ text: 'City' }"
      [colSpan]="6"
    ></dxi-item>

    <dxi-item [dataField]="[AssociationKeys.address, AddressModelKeys.state].join('.')" [colSpan]="3">
      <div *dxTemplate>
        <ag-shr-state-select-box [value]="associationFormData?.address?.state" (valueChange)="setState($event)">
        </ag-shr-state-select-box>
      </div>
    </dxi-item>

    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.zip].join('.')"
      [label]="{ text: 'Zip Code' }"
      [colSpan]="3"
    ></dxi-item>

    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.country].join('.')"
      [label]="{ text: 'Country' }"
      editorType="dxSelectBox"
      [editorOptions]="{
        acceptCustomValue: true,
        items: countries,
        valueExpr: 'name',
        displayExpr: 'name',
        searchEnabled: true,
        placeholder: '',
        inputAttr: { autocomplete: 'disabled' },
      }"
      [colSpan]="6"
    ></dxi-item>

    <dxi-item
      [dataField]="[AssociationKeys.address, AddressModelKeys.county].join('.')"
      [label]="{ text: 'County' }"
      [colSpan]="6"
    ></dxi-item>
  </dx-form>
</dx-scroll-view>
